<template>
  <div class="list-item">
    <div class="list-item__fields">
      <div>
        <v-text-field
          v-model="localService.name"
          name="name"
          class="list-item__input"
          :label="$t('message.common.name')"
          v-validate="'required|max-length:120'"
          :error-messages="[...errors.collect('name'), ...errorMessages]"
          ref="input"
          height="46px"
          outlined
          counter="120"
          required
          @blur="$emit('change')"
          @keyup.enter="$emit('add-custom-service')"
        />

        <ui-button
          v-if="!showDescription"
          text
          small
          class="list-item__description-btn"
          @click="(addDescription = true), (localService.description = '')"
        >
          {{ $t("message.facilityDetails.services.addDescription") }}</ui-button
        >
      </div>
      <v-textarea
        v-show="showDescription"
        v-model="localService.description"
        name="description"
        class="list-item__textarea"
        :label="
          `${$t('message.common.description')} (${$t(
            'message.common.optional'
          )})`
        "
        v-validate="'max-length:300'"
        :error-messages="errors.collect('description')"
        outlined
        no-resize
        required
        rows="5"
        counter="300"
        @blur="$emit('change')"
      />
    </div>
    <div v-if="showRemoveButton" class="list-item__actions">
      <v-btn small icon @click="$emit('remove-custom-service')">
        <v-icon size="20px" color="#787C8B">
          mdi-close
        </v-icon>
      </v-btn>
    </div>
  </div>
</template>

<script>
export default {
  name: "GmbServiceMassCustomServiceListItem",
  props: {
    value: {
      type: Object,
      required: true
    },
    errorMessages: {
      type: Array,
      default: () => []
    },
    showRemoveButton: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      localService: { name: "", description: "" },
      addDescription: false,
      skipInitialValidation: true
    };
  },
  computed: {
    showDescription() {
      return (
        (this.localService.description &&
          this.localService.description.length > 0) ||
        this.addDescription
      );
    }
  },
  methods: {
    focus() {
      this.$refs.input.focus();
    },
    async validateFields() {
      await this.$validator.validateAll();
      this.$emit(
        "validation",
        !this.errors.any() && !this.errorMessages.length
      );
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.focus();
    });
    this.localService = {
      id: this.value.id,
      name: this.value.name || this.value.display_name || "",
      description: this.value.description || ""
    };
  },
  watch: {
    localService: {
      handler() {
        this.$emit("input", this.localService);
        if (!this.skipInitialValidation) {
          this.validateFields();
        }
        this.skipInitialValidation = false;
      },
      deep: true
    }
  }
};
</script>

<style lang="scss" scoped>
.error-message {
  padding-left: $spacing * 1.5;
  color: $danger;
  @include font-size(12px);
}
.list-item {
  background: #f7f7f7;
  border-radius: 8px;
  display: flex;
  padding: $spacing * 1.5 $spacing * 1.5 $spacing * 1.5 $spacing * 1.5;
  gap: $spacing;

  &__error-message {
    padding-left: $spacing * 1.5;
    color: $danger;
    @include font-size(12px);
  }

  &__actions {
    display: flex;
    align-items: flex-start;
    justify-content: center;
    padding-top: $spacing;
  }

  &__description-btn {
    color: $grey-darker;
    font-weight: 500;
    line-height: 12px;
    margin-top: $spacing * 0.5;

    ::v-deep.v-btn__content {
      color: $gray-dark;
    }
  }

  &__fields {
    display: flex;
    flex-direction: column;
    width: 100%;
    gap: $spacing * 0.75;
  }

  &__textarea {
    ::v-deep textarea {
      line-height: 20px;
    }
  }

  &__input,
  &__textarea {
    @include font-size(14px);
    ::v-deep.v-label {
      @include font-size(14px);
    }
  }

  &__input {
    ::v-deep.v-input__slot {
      min-height: 42px !important;
      height: 42px !important;
    }

    ::v-deep.v-label {
      top: $spacing * 1.45;

      &--active {
        margin-top: 4px;
      }
    }
  }
}
</style>
